export default __webpack_public_path__ + "static/media/noun-late.382d99a9.svg";